export default __webpack_public_path__ + "static/brcc-full-width-4-mobile-c421fd41272209dc02d95a65ce29f007.webp";